module.exports = __webpack_public_path__ + "application/directives/svg-image/doc-svg/doc-svg.template.html";